/**
 * Layout tokens for larger accessibility type (iOS/Android text size,
 * browser zoom). Do not freeze font size. Let copy reflow, wrap long names
 * as a unit, and keep vertically centered screens from clipping.
 */
export const TEXT_REFLOW_INLINE_NAME_CLASS =
  "inline-block max-w-full min-w-0 break-words text-balance";

export const TEXT_REFLOW_COPY_CLASS = "min-w-0 break-words text-pretty";

export const TEXT_REFLOW_DISPLAY_CLASS =
  "max-w-full min-w-0 break-words text-balance";

export const TEXT_REFLOW_SAFE_CENTER_CLASS = "reflow-safe-center";

export const NAV_BAR_INNER_CLASS =
  "mx-auto flex h-16 w-full min-w-0 max-w-7xl items-center justify-between gap-2 overflow-hidden px-3 sm:px-6 lg:px-12";

export const NAV_BRAND_LINK_CLASS =
  "flex min-w-0 items-center gap-2 overflow-hidden no-underline sm:gap-2.5";

export const NAV_WORDMARK_CLASS =
  "min-w-0 truncate font-serif text-[15px] leading-none font-bold tracking-tight text-(--mk-cream) sm:text-xl";

export const NAV_ACTIONS_CLASS =
  "relative z-10 isolate flex shrink-0 items-center gap-1.5 sm:gap-3";

export const NAV_LANGUAGE_TRIGGER_CLASS =
  "inline-flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-lg text-(--mk-cream-75) transition-colors hover:bg-(--mk-cream-surface) hover:text-(--mk-cream)";

